import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { SpinnerComponent } from '../spinner/spinner.component';
import { TipsService } from '../../../shared/services/tips.service';
import { Tip } from '../../../shared/models/tip';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { endpoints } from '../../../shared/endpoints';

@Component({
  selector: 'create-assess-case',
  standalone: true,
  imports: [
    CommonModule,
    SpinnerComponent,
    FormsModule
  ],
  templateUrl: './create-assess-case.component.html',
  styleUrl: './create-assess-case.component.css'
})
export class CreateAssessCaseComponent {

  @Input() tip!: Tip;
  @Output() onClose = new EventEmitter<void>();
  @Output() onSave = new EventEmitter<{ student_identifier: string }>();

  studentSSID: string = "";
  messageModal: string | null = null;
  assessRelExists: boolean | null = null;
  popupMessage: string | null = null;
  loading: boolean = false;

  constructor(
    private tipsService: TipsService,
    private http: HttpClient
  ) {}

  ngOnInit(): void {
    if (this.tip && this.tip.id) {
      this.http.post<{ has_error: boolean; payload: any }>(`${environment.apiBaseUrl}${endpoints.findTipsAssessRel}`, { tip_id: this.tip.id }).subscribe({
        next: (response) => {
          this.assessRelExists = !response.has_error && !!response.payload;
        },
        error: () => {
          this.assessRelExists = false;
        }
      });
    }
  }

  handleCloseStudentSSID(): void {
    this.onClose.emit();
  }

  submitStudentSSID(): void {
    if (!this.studentSSID || this.studentSSID.trim() === "") {
      return; // input empty
    }

    this.onSave.emit({ student_identifier: this.studentSSID });
  }

}
